'use client'

/* eslint-disable react/no-danger */
import Image from 'next/image'
import { type AutoWidgetVariant } from 'src/enums/AutoProduct'
import { ButtonType } from 'src/enums/ButtonType'
import { BannerIconPosition } from 'src/enums/NewFlowBanner'
import { Button } from '../AutoWidgetButton/button'
import styles from './newFlowBanner.module.scss'

interface Icon {
  src?: string
  alt?: string
  position?: BannerIconPosition
  width: number
  height: number
}

export interface NewFlowBannerProps {
  title: string
  subTitle: string
  icon: Icon
  ctaText: string
  redirectionUrl: string
  InsuretrackEventName?: string
  InsureSegmentTrackProps?: object
  widgetVariant?: AutoWidgetVariant
  isBottomFloater?: boolean
  isOldLayout?: boolean
  isSeoPurpleVariant?: boolean
}

const NewFlowBanner = ({
  title,
  subTitle,
  icon,
  ctaText,
  redirectionUrl,
  InsuretrackEventName,
  InsureSegmentTrackProps,
  widgetVariant,
  isBottomFloater,
  isSeoPurpleVariant = false,
  isOldLayout = false,
}: NewFlowBannerProps) => {
  const onCtaClick = () => {
    window.location.href = redirectionUrl
  }

  return (
    <div
      className={`${styles.newFlowRootContainer} ${isOldLayout && !isBottomFloater ? styles.newSemDesktopVariant : styles.newSeoVariant
        } ${isSeoPurpleVariant && styles.newSeoPurpleVariant} ${isBottomFloater ? styles.bottomFloater : ''}`}>
      <div
        className={`${styles.bannerDetails} ${icon?.position === BannerIconPosition.right && styles.rightImageVariant
          }`}>
        <div className={styles.leftContainer}>
          {icon?.position === BannerIconPosition.left && icon?.src ? (
            <Image
              className={styles.icon}
              src={icon?.src}
              alt={icon?.alt || ''}
              width={icon?.width}
              height={icon?.height}
            />
          ) : null}
          <div className={styles.textContainer}>
            <div className={`${styles.title} ${isOldLayout && styles.flipFont}`}>{title}</div>
            <div className={`${styles.subTitle} ${isOldLayout && styles.flipFont}`}>{subTitle}</div>
          </div>
        </div>
        {icon?.position === BannerIconPosition.right && icon?.src ? (
          <Image
            className={styles.icon}
            src={icon?.src}
            alt={icon?.alt || ''}
            width={icon?.width}
            height={icon?.height}
          />
        ) : null}

        {isOldLayout && !isBottomFloater ? (
          <div className={styles.newFlowshowOnlyWeb}>
            <Button
              onClick={onCtaClick}
              ctaText={ctaText}
              type={ButtonType.White}
              segmentEventName={InsuretrackEventName}
              segmentEventProps={InsureSegmentTrackProps}
            />
          </div>
        ) : null}
      </div>
      <div className={styles.newFlowShowOnlyMweb}>
        <Button
          onClick={onCtaClick}
          ctaText={ctaText}
          type={ButtonType.White}
          segmentEventName={InsuretrackEventName}
          segmentEventProps={InsureSegmentTrackProps}
        />
      </div>
    </div>
  )
}

export default NewFlowBanner
